import React, { useEffect } from 'react';
import Modal from '@mui/material/Modal';
import Paper from '@mui/material/Paper';
import List from '@mui/material/List';
import ListItem from '@mui/material/ListItem';
import ListItemText from '@mui/material/ListItemText';
import CloseIcon from '@mui/icons-material/Close';	
import Button from '@mui/material/Button';
import './LocationsModal.scss';	
import { useDispatch, useSelector } from 'react-redux';
import{selectLocationsList, selectLocations, selectBusinessName} from '../../../../redux/saga/adminFlow/merchantInfoSelector';
import {LOCATION_TEXT, CLOSE_TEXT, LOC_TEXT } from'../../../../constants/Admin/adminConstants';
import { viewLocationDetailsSaga, viewLocationDetailsErrorSaga } from '../../../../redux/saga/transactionSelectors';
import { activelocationslist } from '../../../../redux/actions/adminFlow/merchantInfoAction';


const LocationsModal = ({ open, onClose }) => {

	const dispatch = useDispatch();

	const viewLocationDetails = useSelector(viewLocationDetailsSaga);
	const locationName = viewLocationDetails?.data?.[0]?.name || '';

	useEffect(() => {
		if (viewLocationDetails && viewLocationDetails.data) {
			const totaladdresslists = viewLocationDetails.data.map(item => {
				const addressParts = [
					item.address.address_line_1,
					item.address.address_line_2,
					item.address.city,
					item.address.state,
					item.address.postal_code
				];
				const formattedAddress = addressParts.filter(part => part).join(', ');
				return {
					name: item.name,
					address: formattedAddress
				};
			});
	
			dispatch(activelocationslist(totaladdresslists));
		}
	}, [viewLocationDetails, dispatch]);

	const locationslist = useSelector(selectLocationsList);
	let activelocationslist1 =  locationslist.locationslist;
	if ((activelocationslist1 === undefined) || (activelocationslist1 === null)){
		const sessionlocationslist = sessionStorage.getItem('activelocationslist');
		if(sessionlocationslist !== null){
			activelocationslist1 = sessionlocationslist.split(',');
		}
	}

	const locationscount = useSelector(selectLocations);
	let activelocationscount =  locationscount.locations;
	if ((activelocationscount === undefined) || (activelocationscount === null)){
		activelocationscount = sessionStorage.getItem('activelocationscount'); 
	}

	const businessName = useSelector(selectBusinessName);
	let activebusinessName=  businessName.businessName;
	if ((activebusinessName === undefined) || (activebusinessName === null)){
		activebusinessName = sessionStorage.getItem('activebusinessname');
		if (activebusinessName === null) {
			activebusinessName = '';
		}
	}

	const handleClose = () => {
        dispatch(activelocationslist([]));
        onClose();
    };

	return (
		<>
			<Modal open={open} onClose={handleClose} data-testid='locations-dialog' className='locations-modal'>

				<Paper>
					<div className='locations-modal-header' data-testid='Location'>
						{/*<h4>{LOCATION_TEXT}</h4>*/}
						<h4>{activebusinessName} {LOC_TEXT} ({activelocationscount})</h4>
							<Button onClick={handleClose}>
								<CloseIcon />
							</Button>
					</div>
					<div className='locations-modal-body'>
						{/*<h6 className='locations-modal-heading'>{locationName} {LOC_TEXT} ({activelocationscount})</h6> */}
						<List>
							{activelocationslist1 && activelocationslist1?.map((item, index) => (
								<ListItem key={index}>
									<div className='address-block'>
										<b>{item.name}</b>
										<ListItemText primary={item.address} />
									</div>
								</ListItem>
							))}
						</List>
					</div>
					<div className='locations-modal-footer' data-testid='Close'>
						<Button className='closeButton-cta'  data-testid='button' onClick={handleClose}>{CLOSE_TEXT}</Button>
					</div>
				</Paper>
			</Modal>
		</>
	);
};

export default LocationsModal;
